import React from "react";
import NestedSelect from "./NestedSelect";

export const CompliancesSection = ({
  employeeContributions,
  employerContributions,
  setEmployerContributions,
  setEmployeeContributions,
  handleChange,
  earnings,
  effectiveDate,
}) => {
  const statesLWF = [
    { state: "Andaman and Nicobar Islands", employeelwf: 0, employerlwf: 0 },
    { state: "Andhra Pradesh", employeelwf: 2.5, employerlwf: 5.83 },
    { state: "Arunachal Pradesh", employeelwf: 0, employerlwf: 0 },
    { state: "Assam", employeelwf: 0, employerlwf: 0 },
    { state: "Bihar", employeelwf: 0, employerlwf: 0 },
    { state: "Chandigarh", employeelwf: 5, employerlwf: 20 },
    { state: "Chhattisgarh", employeelwf: 2.5, employerlwf: 7.5 },
    { state: "Dadra and Nagar Haveli", employeelwf: 0, employerlwf: 0 },
    { state: "Daman and Diu", employeelwf: 0, employerlwf: 0 },
    { state: "Delhi", employeelwf: 0.13, employerlwf: 0.38 },
    { state: "Goa", employeelwf: 10, employerlwf: 30 },
    { state: "Gujarat", employeelwf: 1, employerlwf: 2 },
    { state: "Haryana", employeelwf: 20, employerlwf: 40 },
    { state: "Himachal Pradesh", employeelwf: 0, employerlwf: 0 },
    { state: "Jammu and Kashmir", employeelwf: 0, employerlwf: 0 },
    { state: "Jharkhand", employeelwf: 0, employerlwf: 0 },
    { state: "Karnataka", employeelwf: 1.67, employerlwf: 3.33 },
    { state: "Kerala", employeelwf: 50, employerlwf: 50 },
    { state: "Ladakh", employeelwf: 0, employerlwf: 0 },
    { state: "Lakshadweep", employeelwf: 0, employerlwf: 0 },
    { state: "Madhya Pradesh", employeelwf: 1.67, employerlwf: 5 },
    { state: "Maharashtra", employeelwf: 4.17, employerlwf: 12.5 },
    { state: "Manipur", employeelwf: 0, employerlwf: 0 },
    { state: "Meghalaya", employeelwf: 0, employerlwf: 0 },
    { state: "Mizoram", employeelwf: 0, employerlwf: 0 },
    { state: "Nagaland", employeelwf: 0, employerlwf: 0 },
    { state: "Odisha", employeelwf: 1.67, employerlwf: 3.33 },
    { state: "Puducherry", employeelwf: 0, employerlwf: 0 },
    { state: "Punjab", employeelwf: 5, employerlwf: 20 },
    { state: "Rajasthan", employeelwf: 0, employerlwf: 0 },
    { state: "Sikkim", employeelwf: 0, employerlwf: 0 },
    { state: "Tamil Nadu", employeelwf: 1.67, employerlwf: 3.33 },
    { state: "Telangana", employeelwf: 0.17, employerlwf: 0.42 },
    { state: "Tripura", employeelwf: 0, employerlwf: 0 },
    { state: "Uttar Pradesh", employeelwf: 0, employerlwf: 0 },
    { state: "Uttarakhand", employeelwf: 0, employerlwf: 0 },
    { state: "West Bengal", employeelwf: 0.5, employerlwf: 2.5 },
  ];

  const renderMobileView = (type, contributions) => (
    <div className="space-y-4">
      {Object.entries(contributions).map(([key, value]) => (
        <div
          key={key}
          className="border-gray-200 bg-white p-4 border rounded-md"
        >
          <label className="block mb-2 font-normal text-gray-900 text-sm">
            {type === "employer" ? key !== "pfEDLI" && "Employer" : "Employee"}{" "}
            {key === "professionalTax"
              ? "Professional Tax"
              : key === "pfEDLI"
              ? "PF EDLI & Admin Charges"
              : key.toUpperCase()}
          </label>
          <div className="space-y-2">
            <div>
              {key !== "professionalTax" &&
                key !== "lwf" &&
                key !== "pfEDLI" && (
                  <NestedSelect
                    section={{ type, key }}
                    earnings={earnings}
                    employerContributions={employerContributions}
                    employeeContributions={employeeContributions}
                    setEmployeeContributions={setEmployeeContributions}
                    setEmployerContributions={setEmployerContributions}
                    effectiveDate={effectiveDate}
                  />
                )}
              {key === "pfEDLI" && (
                <div className="relative">
                  <select
                    value={value?.calculation}
                    onChange={(e) => {
                      handleChange(type, key, e.target.value, "type");
                      if (e.target.value === "None") {
                        handleChange(type, key, 0, "amount");
                      } else {
                        handleChange(
                          type,
                          key,
                          parseFloat(
                            earnings?.find(({ name }) => name === "Basic")
                              ?.amount
                          ) * 0.01,
                          "amount"
                        );
                      }
                    }}
                    className="border-gray-200 bg-white border rounded-md w-full font-normal text-[#3A3541] text-sm appearance-none focus:outline-none salary-detailcs"
                  >
                    <option value="None" selected>
                      None
                    </option>
                    <option value="1% Variable">1% Variable</option>
                  </select>
                  <div className="right-0 absolute inset-y-0 flex items-center px-2 pointer-events-none">
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              )}
              {(key === "professionalTax" || key === "lwf") && (
                <div className="relative">
                  <select
                    value={value?.state}
                    onChange={(e) => {
                      const selectedState = e.target.value;
                      const amount = (sectionType) =>
                        type === sectionType
                          ? selectedLWF?.employeelwf || 0
                          : selectedLWF?.employerlwf || 0;
                      // Find the matching state from the statesLWF array
                      const selectedLWF = statesLWF.find(
                        (stateLWF) => stateLWF.state === selectedState
                      );

                      handleChange(
                        "employee",
                        "lwf",
                        amount("employee"),
                        "amount"
                      );
                      handleChange("employee", "lwf", selectedState, "state");
                      handleChange("employee", "professionalTax", 0, "amount");
                      handleChange(
                        "employee",
                        "professionalTax",
                        selectedState,
                        "state"
                      );
                      handleChange(
                        "employer",
                        "lwf",
                        amount("employer"),
                        "amount"
                      );
                      handleChange("employer", "lwf", selectedState, "state");
                    }}
                    className="border-gray-200 bg-white border rounded-md w-full font-normal text-[#3A3541] text-sm appearance-none focus:outline-none salary-detailcs"
                  >
                    <option value="None" selected>
                      None
                    </option>
                    {statesLWF?.map((stateLWF) => (
                      <option value={stateLWF?.state}>{stateLWF?.state}</option>
                    ))}
                  </select>
                  <div className="right-0 absolute inset-y-0 flex items-center px-2 pointer-events-none">
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </div>
            <div className="relative">
              <span className="top-1/2 left-3 absolute text-[#3A3541] -translate-y-1/2">
                ₹
              </span>
              <input
                type="text"
                value={value.amount}
                onChange={(e) =>
                  handleChange(type, key, e.target.value, "amount")
                }
                placeholder="0"
                className="text-right border-gray-200 border rounded-md w-full font-normal text-[#3A3541] text-sm focus:outline-none salary-detailcs"
              />
            </div>
            {type === "employer" && (
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={value.includedInCTC}
                  onChange={(e) =>
                    handleChange(type, key, e.target.checked, "includedInCTC")
                  }
                  className="border-gray-300 rounded w-4 h-4"
                />
                <label className="font-normal text-gray-900 text-sm">
                  Included in CTC
                </label>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );

  const renderTableView = (type, contributions) => (
    <div className="">
      <table className="w-full">
        <thead>
          <tr>
            <th className="pb-4 font-medium w-[316px] text-[#3A3541] text-left text-sm">
              {type === "employer"
                ? "Employer Contributions"
                : "Employee Contributions"}
            </th>
            <th className="pb-4 font-medium text-[#3A3541] text-left text-sm">
              <div className="flex items-center">
                <span className="w-[160px]">Calculation</span>
                <span
                  className="ml-8"
                  style={{
                    visibility: type === "employee" ? "hidden" : "visible",
                  }}
                >
                  Included in CTC
                </span>
              </div>
            </th>
            <th className="pb-4 w-[160px] font-medium text-[#3A3541] text-left text-sm">
              Amount
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(contributions).map(([key, value]) => (
            <tr key={key} className="group">
              <td className="py-2">
                <span className="font-normal text-[#3A3541] text-sm">
                  {type === "employer"
                    ? key !== "pfEDLI" && "Employer"
                    : key !== "professionalTax" && "Employee"}{" "}
                  {key === "professionalTax"
                    ? "Professional Tax"
                    : key === "pfEDLI"
                    ? "PF EDLI & Admin Charges"
                    : key.toUpperCase()}
                </span>
              </td>
              <td className="py-2">
                <div className="flex items-center">
                  <div className="w-[160px]">
                    {key !== "professionalTax" &&
                      key !== "lwf" &&
                      key !== "pfEDLI" && (
                        <NestedSelect
                          section={{ type, key }}
                          earnings={earnings}
                          employerContributions={employerContributions}
                          effectiveDate={effectiveDate}
                          employeeContributions={employeeContributions}
                          setEmployeeContributions={setEmployeeContributions}
                          setEmployerContributions={setEmployerContributions}
                        />
                      )}
                    {key === "pfEDLI" && (
                      <div className="relative">
                        <select
                          value={value?.calculation}
                          onChange={(e) => {
                            handleChange(
                              type,
                              key,
                              e.target.value,
                              "calculation"
                            );
                            if (e.target.value === "None") {
                              handleChange(type, key, 0, "amount");
                            } else {
                              handleChange(
                                type,
                                key,
                                parseFloat(
                                  earnings?.find(({ name }) => name === "Basic")
                                    ?.amount || 0
                                ) * 0.01 || 0,
                                "amount"
                              );
                            }
                          }}
                          className="border-gray-200 bg-white border rounded-md w-full font-normal text-[#3A3541] text-sm appearance-none focus:outline-none salary-detailcs"
                        >
                          <option value="None" selected>
                            None
                          </option>
                          <option value="1% Variable">1% Variable</option>
                        </select>
                        <div className="right-0 absolute inset-y-0 flex items-center px-2 pointer-events-none">
                          <svg
                            className="w-4 h-4 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </div>
                    )}
                    {(key === "professionalTax" || key === "lwf") && (
                      <div className="relative">
                        <select
                          value={value?.state}
                          onChange={(e) => {
                            const selectedState = e.target.value;
                            const amount = (sectionType) =>
                              type === sectionType
                                ? selectedLWF?.employeelwf || 0
                                : selectedLWF?.employerlwf || 0;
                            // Find the matching state from the statesLWF array
                            const selectedLWF = statesLWF.find(
                              (stateLWF) => stateLWF.state === selectedState
                            );

                            handleChange(
                              "employee",
                              "lwf",
                              amount("employee"),
                              "amount"
                            );
                            handleChange(
                              "employee",
                              "lwf",
                              selectedState,
                              "state"
                            );
                            handleChange(
                              "employee",
                              "professionalTax",
                              0,
                              "amount"
                            );
                            handleChange(
                              "employee",
                              "professionalTax",
                              selectedState,
                              "state"
                            );
                            handleChange(
                              "employer",
                              "lwf",
                              amount("employer"),
                              "amount"
                            );
                            handleChange(
                              "employer",
                              "lwf",
                              selectedState,
                              "state"
                            );
                          }}
                          className="border-gray-200 bg-white border rounded-md w-full font-normal text-[#3A3541] text-sm appearance-none focus:outline-none salary-detailcs"
                        >
                          <option value="None" selected>
                            None
                          </option>
                          {statesLWF?.map((stateLWF) => (
                            <option value={stateLWF?.state}>
                              {stateLWF?.state}
                            </option>
                          ))}
                        </select>
                        <div className="right-0 absolute inset-y-0 flex items-center px-2 pointer-events-none">
                          <svg
                            className="w-4 h-4 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="ml-8">
                    {/* {key === "pfEDLI" ? (
                      <span className="text-[#3A3541] text-sm"
                        style={{
                          visibility: type === 'employee' ? 'hidden' : 'visible',
                        }}>{employerContributions?.pf?.includedInCTC ? 'Yes' : 'N/A'}</span>
                    ) : ( */}
                    <input
                      type="checkbox"
                      checked={value.includedInCTC}
                      onChange={(e) =>
                        handleChange(
                          type,
                          key,
                          !value.includedInCTC,
                          "includedInCTC"
                        )
                      }
                      className="border-gray-300 rounded w-4 h-4"
                      style={{
                        visibility: type === "employee" ? "hidden" : "visible",
                      }}
                    />
                    {/* )} */}
                  </div>
                </div>
              </td>
              <td className="py-2">
                {key !== "professionalTax" && (
                  <div className="relative ml-auto w-[160px]">
                    <span className="top-1/2 left-3 absolute text-[#3A3541] -translate-y-1/2">
                      ₹
                    </span>
                    <input
                      disabled={true}
                      type="text"
                      value={value.amount}
                      onChange={(e) =>
                        handleChange(type, key, e.target.value, "amount")
                      }
                      placeholder="0"
                      className="text-right border-gray-300 bg-white disabled:bg-[#fff] border rounded-md w-full font-normal text-[#3A3541] text-sm placeholder:text-[#3A3541] disabled:cursor-not-allowed focus:outline-none salary-detailcs"
                    />
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="w-full">
      <div className="bg-[#F4F5F9] px-6 py-3 rounded-md">
        <h2 className="font-medium text-lg">Compliances</h2>
      </div>

      <div className="space-y-8 md:px-6 py-4">
        <section>
          <div className="sm:hidden">
            {renderMobileView("employer", employerContributions)}
          </div>
          <div className="sm:block hidden">
            {renderTableView("employer", employerContributions)}
          </div>
        </section>

        <section>
          <div className="sm:hidden">
            {renderMobileView("employee", employeeContributions)}
          </div>
          <div className="sm:block hidden">
            {renderTableView("employee", employeeContributions)}
          </div>
        </section>
      </div>
    </div>
  );
};
